// Matrix v2 — theme tokens (jediny zdroj pravdy pre dizajn)
// Ustava sek. 21.15: zelena=pridat, cervena=zmazat, modra=navigacia, amber=final sucet
// Ustava sek. 54.6: focus indicator modry #0369a1

export const COLORS = {
  // vzhlad_predajne_v1 (19. 10. 2026, ústava 61.10): farby Predajne — modrá #1D4ED8 hlavná, sivé pozadie, biele karty.
  // GESTÁ FARBY (z ustavy 21.15)
  // vzhlad_v1 (7. 10. 2026): gestá podľa 21.15 zostávajú, len stíšené — na papieri nekričia a dajú sa čítať.
  add:    '#15803D',  // zelena — pridat / pozitivne / OK / Ulozit
  addBg:  'rgba(21, 128, 61, 0.08)',
  remove: '#B91C1C',  // cervena — zmazat / destruktivne (vzdy cervene + potvrdenie)
  removeBg:'rgba(185, 28, 28, 0.07)',
  nav:    '#1D4ED8',  // modra — navigacia + medzisucty + FOCUS OUTLINE (54.6)
  navBg:  '#EFF6FF',
  total:  '#B45309',  // amber — finalny / premium sucet (VYMERA ZAKAZKY)
  totalBg:'rgba(180, 83, 9, 0.08)',

  // ZNAČKA KAMIR (ústava 61.6) — oranžová + čierna z loga.
  // brand = výrazné pozadie hlavičiek kariet · brandText = čierny text na ňom.
  brand:     '#C4601F',   // vzhlad_v1: značka ostáva (61.6), ale na papieri drží kontrast; pásik, nie pozadie
  brandD:    '#8C4215',   // V3 (N08): tmavšia značka na text — Ui.jsx ju používal, v téme chýbala
  brandText: '#111',

  // ZAKLAD (text/pozadie)
  base:   '#0F172A',
  text:   '#1E293B',
  muted:  '#64748B',
  line:   '#E2E8F0',   // rámček karty (61.10)
  lineSoft:'#EEF1F5',
  bg:     '#FFFFFF',   // plocha, na ktorej sa pracuje
  bgSoft: '#F8FAFC',   // jemná výplň vnútri karty (hlavička tabuľky, pätka zoznamu)
  page:   '#F4F5F7',   // 61.10: sivé pozadie obrazovky, na ňom biele karty

  // STATUS (akcia state)
  hover:  '#F8FAFC',
  active: '#EFF6FF',
  disabled:'#94A3B8',
  warn:   '#B45309',
  info:   '#1D4ED8'
}

export const TYPO = {
  // SK-friendly font stack
  // vzhlad_v1: Archivo nesie text, IBM Plex Mono značky, čísla a sumy. Oboje sa načítava v index.html.
  family: 'Archivo, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, sans-serif',
  mono:   '"IBM Plex Mono", ui-monospace, "SF Mono", Menlo, Consolas, monospace',
  sizes: {
    xs: 11,
    sm: 12,
    base: 13,    // default UI
    md: 14,
    lg: 18,
    xl: 22,
    xxl: 28
  },
  weights: {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extra: 800
  },
  line: {
    tight: 1.2,
    base: 1.5,
    relaxed: 1.7
  }
}

export const SPACE = {
  // 4 px grid
  px:  1,
  xs:  4,
  sm:  8,
  md:  12,
  lg:  16,
  xl:  24,
  xxl: 32,
  xxxl: 48
}

export const RADIUS = {
  // vzhlad_v1: takmer ostré rohy. Zaoblené kartičky sú to, podľa čoho sa pozná softvér z fabriky.
  // vzhlad_predajne_v1: rohy Predajne — karta 8 px, prvky v karte 6 px (61.10)
  sm: 4,
  md: 6,    // default tlacidlo / input
  lg: 8,
  xl: 8,
  full: 9999
}

export const SHADOW = {
  none: 'none',
  sm:   '0 1px 2px rgba(0,0,0,0.05)',
  md:   '0 2px 4px rgba(0,0,0,0.08)',
  lg:   '0 4px 12px rgba(0,0,0,0.12)',
  modal:'0 10px 40px rgba(0,0,0,0.20)'
}

// Breakpointy: mobile-first
export const BREAKPOINTS = {
  mobile:  640,   // < 640 mobil
  tablet:  960,   // 640-959 tablet
  desktop: 1280,  // 960-1279 small desktop / Jana Galova Fujitsu 1366x768 spada sem
  wide:    1600   // 1280+ wide desktop
}

// Z-INDEX hierarchia (vyssi = vyssie)
export const Z_INDEX = {
  base:    1,
  sidebar: 100,
  topnav:  200,
  dropdown:500,
  toast:   9000,
  modal:   8000,
  cheatsheet: 9500   // ? cheatsheet je vzdy hore
}

// FOCUS outline (ustava 54.6) — pouzit v styli :focus-visible
export const FOCUS_OUTLINE = `2px solid ${COLORS.nav}`
export const FOCUS_OFFSET  = '2px'

// SK-locale helpers
export const SK = {
  // Cislo na string s ciarkou (ustava 54.3)
  fmt: (n, decimals = 2) => {
    if (n === null || n === undefined || n === '') return ''
    const num = typeof n === 'string' ? parseFloat(n.replace(',', '.')) : n
    if (isNaN(num)) return ''
    return num.toFixed(decimals).replace('.', ',')
  },
  // String s ciarkou -> number (parse)
  parse: (s) => {
    if (typeof s !== 'string') return s
    const cleaned = s.replace(/\s/g, '').replace(',', '.')
    const n = parseFloat(cleaned)
    return isNaN(n) ? null : n
  },
  // Datum DD.MM.YYYY (sek. 20 Europe/Bratislava)
  date: (d) => {
    if (!d) return ''
    const dt = typeof d === 'string' ? new Date(d) : d
    if (isNaN(dt)) return String(d)
    return `${String(dt.getDate()).padStart(2,'0')}.${String(dt.getMonth()+1).padStart(2,'0')}.${dt.getFullYear()}`   // V3 131.8: 15.09.2026 (predtým 15-09-2026)
  },
  // CAS_ODOSLANIA_V1 (Mirko 21. 10. 2026: „a čas odoslania? to ma byt vsade“): dátum a čas, miestny čas Slovenska.
  // SQLite datetime('now') je UTC → prepočet; lokalny=true pre stĺpce zapísané ako datetime('now','localtime').
  datumCas: (s, lokalny = false) => {
    if (!s) return ''
    const t = String(s)
    if (!/\d{1,2}:\d{2}/.test(t)) return SK.date(t.slice(0, 10))
    const dt = new Date((/[zZ]|[+-]\d{2}:?\d{2}$/.test(t) || lokalny) ? t.replace(' ', 'T') : t.replace(' ', 'T') + 'Z')
    if (isNaN(dt)) return t
    return SK.date(dt) + ' ' + String(dt.getHours()).padStart(2, '0') + ':' + String(dt.getMinutes()).padStart(2, '0')
  },
  // EUR format: 1 234,56 €
  eur: (n, decimals = 2) => {
    const formatted = SK.fmt(n, decimals)
    if (!formatted) return ''
    // Tisicovy oddelovac (medzera)
    const [whole, frac] = formatted.split(',')
    const withSep = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    return frac !== undefined ? `${withSep},${frac} €` : `${withSep} €`
  }
}

// ── TINT — jemné pozadia (zriedené gestá farby, ústava 21.15) ──────────
// KĽÚČ pre celý Matrix v2 — žiadne inline farby pozadia, vždy odtiaľto.
// „Dnes“ a dátum podľa slovenského času (ústava 20, V3 131.8) — nikdy nie UTC cez toISOString():
// v lete by medzi 00:00 a 02:00 vyšiel včerajšok.
export function localISODate(d = new Date()) {
  try {
    const p = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Bratislava', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(d)
    const g = t => (p.find(x => x.type === t) || {}).value
    if (g('year') && g('month') && g('day')) return `${g('year')}-${g('month')}-${g('day')}`
  } catch (_) {}
  const z = new Date(d.getTime() - d.getTimezoneOffset() * 60000)
  return z.toISOString().slice(0, 10)
}
export const todayLocal = () => localISODate(new Date())

// Hľadanie bez diakritiky a veľkosti písmen (ústava 66.1 bod 3, V3): „kovac“ nájde „Kováč“.
export const norm = (v) => String(v == null ? '' : v).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
// p108 — JEDNO HĽADANIE PRE CELÝ MATRIX (ústava 66.1; Mirko 22. 9. 2026: „vyhľadávanie nech nerozlišuje diakritiku — je to
// obrovský problém" a „chrbtica nemôže robiť ruka niečo iné ako chce mozog"). hladaj(text, co) = obsahuje text hľadané slovo
// bez ohľadu na diakritiku a veľké písmená („kovac" nájde „Kováč", „jurkovsky" nájde „Jurkovský"); prázdne hľadanie = všetko.
// Žiadna obrazovka si nepíše vlastné porovnanie (toLowerCase().includes) — stráž v nasadzovacom skripte ho zastaví.
export const hladaj = (text, co) => { const q = norm(co).replace(/\s+/g, ' ').trim(); return !q || norm(text).replace(/\s+/g, ' ').includes(q) }   // MZDY_KARTA_ZOSIT_V1: viac medzier = jedna

export const TINT = {
  nav:    'rgba(29,78,216,0.045)',    // modrá — hlavičky sekcií / navigácia
  add:    'rgba(21,128,61,0.045)',   // zelená — súčty / pozitívne
  total:  'rgba(180,83,9,0.055)',   // amber — finálny súčet (SPOLU)
  remove: 'rgba(185,28,28,0.045)',   // červená — varovné sekcie
  zebra:  'rgba(0,0,0,0.016)'        // striedavý riadok (zebra)
}

// tint(hex, alpha) — zriedi ľubovoľnú hex farbu na jemné rgba pozadie.
// Použitie: farba kategórie partie (schedule_groups.color) → jemné pozadie riadkov.
export function tint(hex, alpha = 0.06) {
  if (!hex || typeof hex !== 'string' || hex[0] !== '#') return `rgba(0,0,0,${alpha})`
  let h = hex.slice(1)
  if (h.length === 3) h = h.split('').map(c => c + c).join('')
  const r = parseInt(h.slice(0, 2), 16), g = parseInt(h.slice(2, 4), 16), b = parseInt(h.slice(4, 6), 16)
  if ([r, g, b].some(Number.isNaN)) return `rgba(0,0,0,${alpha})`
  return `rgba(${r},${g},${b},${alpha})`
}

// ── CELL — farby POZADIA buniek tabuliek (ústava sek. 61.4) ──────
// Pozadie bunky = jej význam. Jemný kontrast — prečítaš na prvý pohľad.
// POUŽITIE: vstupné pole → { background: CELL.input.bg, border:`1px solid ${CELL.input.border}` }
//          súčet riadok  → { background: CELL.sum.bg,   color: CELL.sum.text }
// Žiadne inline farby pozadia — vždy odtiaľto (ústava 21.15 + 61).
export const CELL = {
  normal: { bg: '#ffffff' },                                          // bežná bunka
  input:  { bg: '#fdf6ec', border: '#d9a066' },                       // vstupné pole (krémová)
  sum:    { bg: 'rgba(34,197,94,0.10)',  text: '#15803d' },           // súčet / SPOLU
  final:  { bg: 'rgba(245,158,11,0.13)', text: '#b45309' },           // finálny / zvýraznený
  header: { bg: '#EFF6FF',  text: '#1D4ED8' },           // hlavička / medzisúčet
  zebra:  { bg: 'rgba(0,0,0,0.025)' },                                // párny riadok (zebra)
  page:   { bg: '#F4F5F7' }                                           // pozadie stránky
}

// Detekcia OS pre klavesove skratky (ustava 54.4 — Ctrl/Cmd auto-detect)
export const IS_MAC = typeof navigator !== 'undefined' && /Mac|iPod|iPhone|iPad/.test(navigator.platform)
export const MOD_KEY = IS_MAC ? '⌘' : 'Ctrl'
export const MOD_KEY_CODE = IS_MAC ? 'meta' : 'ctrl'   // pre react-hotkeys-hook

export default { COLORS, TYPO, SPACE, RADIUS, SHADOW, BREAKPOINTS, Z_INDEX, TINT, tint, CELL, FOCUS_OUTLINE, FOCUS_OFFSET, SK, IS_MAC, MOD_KEY, MOD_KEY_CODE }
